import { Model } from "@google/model-viewer/lib/features/scene-graph/model";
import TwoWheelsAsset from "../../assets/portfolio/project03/ar/500g.glb";
import ApartmentAsset from "../../assets/portfolio/project08/ar/Apartment.glb";
import MatressAsset from "../../assets/portfolio/project01/ar/Cinza_AR.glb";

import project07_Black_01 from "../../assets/portfolio/project07/ar/Black_01.glb";
import project07_Black_02 from "../../assets/portfolio/project07/ar/Black_02.glb";
import project07_Black_03 from "../../assets/portfolio/project07/ar/Black_03.glb";
import project07_Black_04 from "../../assets/portfolio/project07/ar/Black_04.glb";
import project07_Copper_01 from "../../assets/portfolio/project07/ar/Copper_01.glb";
import project07_Copper_02 from "../../assets/portfolio/project07/ar/Copper_02.glb";
import project07_Copper_03 from "../../assets/portfolio/project07/ar/Copper_03.glb";
import project07_Copper_04 from "../../assets/portfolio/project07/ar/Copper_04.glb";

import project07_White_01 from "../../assets/portfolio/project07/ar/White_01.glb";
import project07_White_02 from "../../assets/portfolio/project07/ar/White_02.glb";
import project07_White_03 from "../../assets/portfolio/project07/ar/White_03.glb";
import project07_White_04 from "../../assets/portfolio/project07/ar/White_04.glb";


const importAllImages = (requireContext) => {
  return requireContext.keys().map(requireContext);
};


const projeto1 = importAllImages(require.context("../../assets/portfolio/project01", false, /\.(png|jpe?g|svg|gif)$/));
const projeto2 = importAllImages(require.context("../../assets/portfolio/project02", false, /\.(png|jpe?g|svg|gif)$/));
const projeto3 = importAllImages(require.context("../../assets/portfolio/project03", false, /\.(png|jpe?g|svg|gif)$/));
const projeto4 = importAllImages(require.context("../../assets/portfolio/project04", false, /\.(png|jpe?g|svg|gif)$/));
const projeto5 = importAllImages(require.context("../../assets/portfolio/project05", false, /\.(png|jpe?g|svg|gif)$/));
const projeto6 = importAllImages(require.context("../../assets/portfolio/project06", false, /\.(png|jpe?g|svg|gif)$/));
const projeto7 = importAllImages(require.context("../../assets/portfolio/project07", false, /\.(png|jpe?g|svg|gif)$/));
const projeto8 = importAllImages(require.context("../../assets/portfolio/project08", false, /\.(png|jpe?g|svg|gif)$/));

const projects = [
        {
          id: "4",
          preview: projeto3[2],
          title: "2WHEELS",
          tag: "industry",
          modelType: "ar",
          images: projeto3,
          models: [
            {
              id: "1",
              modelSrc: TwoWheelsAsset,
              coverImage: projeto3[5],
              title: "Modelo 1",
            },
          ],
        },
        {
          id: "6",
          preview: projeto7[1],
          title: "Prateleira",
          tag: "furniture",
          modelType: "ar",
          images: projeto7,
          models: [
            {
              id: "1",
              modelSrc: project07_Black_01,
              coverImage: projeto7[0],
              title: "Modelo 1",
            },
            {
              id: "2",
              modelSrc: project07_Black_02,
              coverImage: projeto7[2],
              title: "Modelo 2",
            },
            {
              id: "3",
              modelSrc: project07_Black_03,
              coverImage: projeto7[4],
              title: "Modelo 3",
            },
            {
              id: "4",
              modelSrc: project07_Black_04,
              coverImage: projeto7[6],
              title: "Modelo 4",
            },
            {
              id: "5",
              modelSrc: project07_Copper_01,
              coverImage: projeto7[8],
              title: "Modelo 5",
            },
            {
              id: "6",
              modelSrc: project07_Copper_02,
              coverImage: projeto7[10],
              title: "Modelo 6",
            },
            {
              id: "7",
              modelSrc: project07_Copper_03,
              coverImage: projeto7[12],
              title: "Modelo 5",
            },
            {
              id: "8",
              modelSrc: project07_Copper_04,
              coverImage: projeto7[14],
              title: "Modelo 4",
            },
            {
              id: "9",
              modelSrc: project07_White_01,
              coverImage: projeto7[16],
              title: "Modelo 4",
            },
            {
              id: "10",
              modelSrc: project07_White_02,
              coverImage: projeto7[18],
              title: "Modelo 10",
            },
            {
              id: "11",
              modelSrc: project07_White_03,
              coverImage: projeto7[20],
              title: "Modelo 11",
            },
            {
              id: "12",
              modelSrc: project07_White_04,
              coverImage: projeto7[22],
              title: "Modelo 12",
            },
          ],
        },
        {
          id: "7",
          preview: projeto8[0],
          title: "Apartment",
          tag: "archviz",
          modelType: "ar",
          images: projeto8,
          models: [
            {
              id: "1",
              modelSrc: ApartmentAsset,
              coverImage: projeto8[0],
              title: "Modelo 1",
            },
          ],
        },
        {
          id: "1",
          preview: projeto1[2],
          title: "Fabrispuma",
          tag: "furniture",
          modelType: "ar",
          images: projeto1,
          models: [
          {
            id: "1",
            modelSrc: MatressAsset,
            coverImage: projeto1[10],
            title: "Paris Cinza",
          },
        ],
        },
        {
          id: "2",
          preview: projeto6[1],
          title: "P4 Cabeceiras",
          tag: "furniture",
          modelType: "image",
          images: projeto6
        },
        {
          id: "3",
          preview: projeto4[0],
          title: "Gutche",
          tag: "branding",
          modelType: "image",
          images: projeto4
        },
        {
          id: "5",
          preview: projeto5[1],
          title: "Straub",
          tag: "furniture",
          modelType: "image",
          images: projeto5
        },
        {
          id: "8",
          preview: projeto2[0],
          title: "Straub",
          tag: "furniture",
          modelType: "image",
          images: projeto2
        },
      ];

export default projects;